<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
<path d="M4.00016 1.33333H1.3335V3.99999H4.00016V1.33333ZM14.6668 12H12.0002V14.6667H14.6668V12ZM4.00016 12H1.3335V14.6667H4.00016V12ZM14.6668 1.33333H12.0002V3.99999H14.6668V1.33333Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M2.6665 12V4.00001M13.3332 12V4.00001M3.99984 2.66667H11.9998M3.99984 13.3333H11.9998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
